import { DeviceStagesTimeline } from "src/constants/enums";
import { ExamStatusType, ExamType } from "src/services/exams/types";

// gets the active step for the timeline component on the live update modal
export const getActiveStep = ({
  exam,
  possibleSteps,
  examStatus,
}: {
  exam: ExamType | undefined;
  possibleSteps: Array<number | undefined>;
  examStatus: ExamStatusType;
}) => {
  if (!exam || !examStatus) return { index: -1, value: -1 };

  const index = possibleSteps.findIndex(
    (stepValue) => stepValue === examStatus.timelineStage
  );
  return { index, value: examStatus.timelineStage };
};

// get all device stages on the live update stepper component
export const getDeviceStagesTimelineText = ({
  stage,
  isExamOrTutorial,
  extraExamWord,
  t,
}: {
  stage: number;
  isExamOrTutorial: boolean;
  extraExamWord: string | undefined;
  t: (key: string) => string;
}) => {
  switch (stage) {
    case DeviceStagesTimeline.PatientLogin:
      return t("Patient Login");
    case DeviceStagesTimeline.Confirmation:
      return t("Confirmation");
    case DeviceStagesTimeline.Tutorial:
      if (isExamOrTutorial) return `${t("Tutorial")} (${extraExamWord})`;
      return t("Tutorial");
    case DeviceStagesTimeline.Calibration:
      return t("Calibration");
    case DeviceStagesTimeline.Exam:
      if (isExamOrTutorial) return `${t("Exam")} (${extraExamWord})`;
      return t("Exam");
    case DeviceStagesTimeline.Completed:
      return t("Completed");
    default:
      return undefined;
  }
};
